import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";
import Header from "common/js/header/header";
import Loader from "common/components/Loader";
import { getClassPeriodsOffListSvc, getPeriodsListSvc } from "./clsWisePeriodOffSvc";


const ClassPeriodsOffCtrl = () => {

    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [lstCls, setLstCls] = useState([]);
    const [lstClsFiltered, setLstClsFiltered] = useState([]);
    const [lstPeirods, setLstPeriods] = useState([]);
    const [clsSecFiltered, setClsSecFiltered] = useState("");
    const [key, setKey] = useState(0);

    useEffect(() => {
        // console.log("ClassPeriodsOffCtrl called");
        getPeriodList();
        getClassPeriods();
    }, [key]);


    const getPeriodList = () => {
        // console.log("getPeriodList called");
        setLoader("block");
        setOpacity(0.5);
        getPeriodsListSvc(periodsListResponse);
    }


    const periodsListResponse = (data) => {
        // console.log("periodsListResponse called, data", data);
        if (data.status === "Success") {
            setLstPeriods(data.lstMstPeriod);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }

    const getClassPeriods = () => {
        // console.log("getClassPeriods called");
        setLoader("block");
        setOpacity(0.5);
        getClassPeriodsOffListSvc(classPeriodsOffListSvc);
    }


    const classPeriodsOffListSvc = (data) => {
        // console.log("classPeriodsOffListSvc called, data", data);
        if (data.status === "Success") {
            setLstCls(data.lstSection);
            setLstClsFiltered(data.lstSection);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }



    const saveClsPeriods = (clsObj) => {
        // console.log("saveClsPeriods called, clsObj", clsObj);
    }

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    const handleClassFilter = async (pClsSec) => {
        await setClsSecFiltered(pClsSec);
        filterClasses(pClsSec);
    }


    const filterClasses = (pClsSec) => {
        // console.log("filterClasses called, pClsSec", pClsSec);
    }

    const updateKey = () => {
        setKey(prevKey => prevKey + 1);
    }

    const colgrp = <colgroup>
        <col width="30"></col>
        <col width="100"></col>
        <col width="40"></col>
    </colgroup>



    return (

        <div >
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: (loader === "none") ? 'pointer' : 'none',
                    pointerEvents: (loader === "none") ? 'auto' : 'none',
                    opacity: opacity
                }}>
                <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-centered padding-remove" style={{ marginTop: "30px" }} >
                    <div className="col-md-12 col-xs-12 col-centered padding-remove " >
                        <table className="tableLayout1 table-head-borders" >

                            <thead>
                                <tr>
                                    <th rowSpan={1} colSpan={3}>
                                    </th>
                                    <th rowSpan={1} colSpan={lstPeirods.length}>
                                        Periods
                                    </th>
                                    <th rowSpan={1} colSpan={3}>
                                    </th>
                                </tr>
                                <tr>
                                    <th colSpan={3} className="text-center">
                                        <input
                                            type="text"
                                            className="form-control inp-search"
                                            style={{ textAlign: "left" }}
                                            value={clsSecFiltered}
                                            onChange={(e) => handleClassFilter(e.target.value)}
                                            name="Class Section"
                                            placeholder="Class-section" />
                                    </th>
                                    {
                                        lstPeirods && lstPeirods.length ?
                                            lstPeirods.map((period) => (
                                                <th colSpan={1} className="text-center">{period.period}</th>
                                            ))
                                            : null
                                    }
                                    <th colSpan={3} className="text-center">
                                        Action
                                    </th>
                                </tr>
                            </thead>
                        </table>
                        <div className="tableDiv" style={{ height: "60vh" }}>
                            <table className="tableLayout">
                                <tbody id="clsPeriodsOffTable" >
                                    {lstClsFiltered.map((cls, clsIndex) => (
                                        <tr key={clsIndex}>
                                            <td colSpan={3} className="text-left">{cls.className}</td>
                                            {cls.periods.map((p, periodIndex) => (
                                                <td key={periodIndex} colSpan={1} className="text-center">
                                                    <input
                                                        type="checkbox"
                                                        checked={p === 1}
                                                        onChange={() => {
                                                            const updatedList = [...lstClsFiltered];
                                                            updatedList[clsIndex].periods[periodIndex] = p === 1 ? 0 : 1;
                                                            setLstClsFiltered(updatedList);
                                                        }}
                                                    />
                                                </td>
                                            ))}
                                            <td colSpan={3} className="text-center">
                                                <span
                                                    onClick={() => saveClsPeriods(cls)}
                                                    title="Edit Teacher Allocation Details"
                                                    style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                                                >
                                                    Edit
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default ClassPeriodsOffCtrl;